export const REGIONS = {
  KANTO: 1,
  JOHTO: 2,
  HOENN: 3,
  SINNOH: 4,
  UNOVA: 5,
  KALOS: 6,
  ALOLA: 7,
  GALAR: 8,
  HISUI: 9,
  PALDEA: 10,
  ORRE: 11,
} as const;

export const PAL_PARK_AREAS = {
  FOREST: 1,
  FIELD: 2,
  MOUNTAIN: 3,
  POND: 4,
  SEA: 5,
} as const;
